module.exports = __webpack_public_path__ + "static/Pseudodragon-d8db1600df4ff9860e182d280a6e6dc2.jpg";